/**
 * Country options for the per-account proxy geo selector. These must stay in sync
 * with the `supportedCountries` array returned by `GET /api/instagram-accounts/proxy/info`.
 *
 * Display labels are intentionally short. Translations are handled at the call
 * site via the `i18nKey` (so "Estados Unidos" vs "United States" both work).
 */
export interface ProxyCountryOption {
  /** ISO 3166-1 alpha-2 code, lowercase. What we send to the API. */
  code: string;
  /** Translation key under `proxy.countries.<key>`. */
  i18nKey: string;
  /** Fallback English label if the translation is missing. */
  fallback: string;
}

export const PROXY_COUNTRIES: ProxyCountryOption[] = [
  { code: "ar", i18nKey: "ar", fallback: "Argentina" },
  { code: "au", i18nKey: "au", fallback: "Australia" },
  { code: "br", i18nKey: "br", fallback: "Brazil" },
  { code: "ca", i18nKey: "ca", fallback: "Canada" },
  { code: "cl", i18nKey: "cl", fallback: "Chile" },
  { code: "co", i18nKey: "co", fallback: "Colombia" },
  { code: "de", i18nKey: "de", fallback: "Germany" },
  { code: "es", i18nKey: "es", fallback: "Spain" },
  { code: "fr", i18nKey: "fr", fallback: "France" },
  { code: "gb", i18nKey: "gb", fallback: "United Kingdom" },
  { code: "it", i18nKey: "it", fallback: "Italy" },
  { code: "jp", i18nKey: "jp", fallback: "Japan" },
  { code: "mx", i18nKey: "mx", fallback: "Mexico" },
  { code: "nl", i18nKey: "nl", fallback: "Netherlands" },
  { code: "pe", i18nKey: "pe", fallback: "Peru" },
  { code: "pt", i18nKey: "pt", fallback: "Portugal" },
  { code: "us", i18nKey: "us", fallback: "United States" },
  { code: "ve", i18nKey: "ve", fallback: "Venezuela" },
];

export function isSupportedProxyCountry(code: string): boolean {
  return PROXY_COUNTRIES.some((c) => c.code === code.toLowerCase());
}
